<template>
  <div id="app">
    <Header />
      <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from './components/common/Header.vue';
import Footer from './components/common/Footer.vue';

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
}

</script>

<style>
/* sub css */
  @import url('./assets/resource/css/sub.css');
  /* Font */
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');
</style>